import { jsx as _jsx } from "react/jsx-runtime";
import { Inset } from 'syf-component-library/ui/spacing';
import { Small } from 'syf-component-library/ui/typography';
import { translate } from '../../../strings/i18n';
const AddUserLegalContent = () => {
    return (_jsx(Inset, { top: "base", children: _jsx(Small, { children: translate('addAuthUserScreen.legalContent') }) }));
};
export default AddUserLegalContent;
